import styled from 'styled-components'
import { white, grayText } from '@qirapagos/lib/theme/colors'

export const AfterHoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  
  width: 100%;
  max-width: 1044px;
  min-height: 650px;
  background: ${white};
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.09);
  border-radius: 6px;
  margin: 0 auto;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
`

export const SvgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  max-width: 400px;
`

export const MessageText = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 154.7%;
  color: ${grayText};
`

export const BoldText = styled.span`
  font-weight: 600;
`
